import { COMMON_QUERY_CONFIG } from '../shared/configs';

// const VIDEO_CONTENT_TYPE_FILTER = { term: { key: 'ContentType', value: 'video' } };

const QUERIES = {
  WSJ_VIDEO: 'wsj video',
  WSJ_OPINION: 'wsj opinion video',
  VIDEO_PODCAST: 'wsj video podcast',
  OPINION_VIDEO_PODCAST: 'wsj opinion video podcast'
};

const VIDEO_TYPES = {
  VERTICAL: 'vertical'
};

enum SECTION_ENUM {
  WATCH_NOW = 'watch-now',
  OPINION = 'opinion'
}

const COLUMN_NAMES = {
  JOANNA_STERN: "joanna stern's ptech",
  THE_ONE: 'the one - magazine',
  EQUIPPED: 'equipped',
  TECH_BEHIND: 'tech behind',
  THE_ECONOMICS_OF: 'the economics of',
  COVETED: 'coveted',
  PRO_PERFECTED: 'pro perfected'
};

const languageFilter = { term: { key: 'LanguageCode', value: 'en' } };
const videoFilters = [languageFilter, { term: { key: 'Product', value: QUERIES.WSJ_VIDEO } }];
const verticalVideoFilter = { term: { key: 'VideoType', value: VIDEO_TYPES.VERTICAL } };

const LATEST_VIDEOS = {
  query: {
    and: [
      ...videoFilters,
      { term: { key: 'Product', value: QUERIES.VIDEO_PODCAST } },
      { term: { key: 'Product', value: QUERIES.WSJ_OPINION } },
      { term: { key: 'Product', value: QUERIES.OPINION_VIDEO_PODCAST } }
    ],
    not: [verticalVideoFilter]
  },
  ...COMMON_QUERY_CONFIG
};

const WATCH_NOW = {
  query: {
    and: [
      ...videoFilters,
      verticalVideoFilter,
      { term: { key: 'Product', value: QUERIES.WSJ_OPINION } },
      { term: { key: 'Product', value: QUERIES.OPINION_VIDEO_PODCAST } }
    ]
  },
  ...COMMON_QUERY_CONFIG
};

const OPINION = {
  query: {
    and: [
      languageFilter,
      { term: { key: 'Product', value: QUERIES.WSJ_OPINION } },
      { term: { key: 'Product', value: QUERIES.OPINION_VIDEO_PODCAST } }
    ],
    not: [verticalVideoFilter]
  },
  ...COMMON_QUERY_CONFIG
};

const VIDEO_PODCASTS = {
  query: {
    and: [languageFilter, { term: { key: 'Product', value: QUERIES.VIDEO_PODCAST } }],
    not: [verticalVideoFilter]
  },
  ...COMMON_QUERY_CONFIG
};

// export const VIDEO_SERIES = {
//   query: {
//     and: [{ term: { key: 'Product', value: QUERIES.VIDEO_SERIES } }]
//   },
//   ...COMMON_QUERY_CONFIG
// };

const VIDEO_SERIES_JOANNA_STERN = {
  query: {
    and: [...videoFilters, { term: { key: 'ColumnName', value: COLUMN_NAMES.JOANNA_STERN } }]
  },
  ...COMMON_QUERY_CONFIG
};

const VIDEO_SERIES_THE_ONE = {
  query: {
    and: [...videoFilters, { term: { key: 'ColumnName', value: COLUMN_NAMES.THE_ONE } }]
  },
  ...COMMON_QUERY_CONFIG
};

const VIDEO_SERIES_EQUIPPED = {
  query: {
    and: [...videoFilters, { term: { key: 'ColumnName', value: COLUMN_NAMES.EQUIPPED } }]
  },
  ...COMMON_QUERY_CONFIG
};

const VIDEO_SERIES_TECH_BEHIND = {
  query: {
    and: [...videoFilters, { term: { key: 'ColumnName', value: COLUMN_NAMES.TECH_BEHIND } }]
  },
  ...COMMON_QUERY_CONFIG
};

const VIDEO_SERIES_THE_ECONOMICS_OF = {
  query: {
    and: [...videoFilters, { term: { key: 'ColumnName', value: COLUMN_NAMES.THE_ECONOMICS_OF } }]
  },
  ...COMMON_QUERY_CONFIG
};

const VIDEO_SERIES_COVETED = {
  query: {
    and: [...videoFilters, { term: { key: 'ColumnName', value: COLUMN_NAMES.COVETED } }]
  },
  ...COMMON_QUERY_CONFIG
};

const VIDEO_SERIES_PRO_PERFECTED = {
  query: {
    and: [...videoFilters, { term: { key: 'ColumnName', value: COLUMN_NAMES.PRO_PERFECTED } }]
  },
  ...COMMON_QUERY_CONFIG
};

export {
  SECTION_ENUM,
  LATEST_VIDEOS,
  WATCH_NOW,
  OPINION,
  VIDEO_PODCASTS,
  VIDEO_SERIES_JOANNA_STERN,
  VIDEO_SERIES_THE_ONE,
  VIDEO_SERIES_EQUIPPED,
  VIDEO_SERIES_TECH_BEHIND,
  VIDEO_SERIES_THE_ECONOMICS_OF,
  VIDEO_SERIES_COVETED,
  VIDEO_SERIES_PRO_PERFECTED
};
